import { Room } from "@uno/protocol";

const isSame = (a: unknown, b: unknown): boolean => JSON.stringify(a) === JSON.stringify(b);

export const shareUnchanged = (previous: Room | null, next: Room): Room => {
    if(!previous || previous.id !== next.id) {
        return next;
    }

    const players = next.players.map(roomPlayer => {
        const before = previous.players.find(x => x.player.id === roomPlayer.player.id);

        return before && isSame(before, roomPlayer) ? before : roomPlayer;
    });
    const playersUnchanged = players.length === previous.players.length && players.every((roomPlayer, index) => roomPlayer === previous.players[index]);

    return {
        ...next,
        players: playersUnchanged ? previous.players : players,
        spectators: isSame(previous.spectators, next.spectators) ? previous.spectators : next.spectators,
        game: isSame(previous.game, next.game) ? previous.game : next.game,
        gameState: isSame(previous.gameState, next.gameState) ? previous.gameState : next.gameState,
    };
};
